/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Vue, Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ResultPageStatusEnum } from '@/components/result-page';
import type { OrdersV2 } from '@/api/ordersV2/types';
import store from '@/store';
import { appEnv } from '@/components/adv-components';
import { isFatEnv } from '@/constant';
import ProductCommodity from '@/shared/commodity';
import { RightPackageTypeEnum } from '@/api/rights/types';
import ChangeChannelList from '@/components/change-channel';
import { PreApplyItem } from '@/po/PreApplyItem';
import { OrderResultEnum } from '@/enums/orderV2';
import UndertakeInvestors from '../undertake-investors/index.vue';
import AdvApplyingPopup from '../apply-process-popup/index';
import NewResultPage from '../new-result-page';

// 引入平台 nps 组件
import '@hb/compass-nps';
import { handleChannelClick } from '../../utils';


const style = require('./index.module.scss');

const ApplyResultStore = namespace('applyResult');
const HomeStoreNamespace = namespace('homeStore');

// 哈啰用户 token
const { token, userGuid } = store.state.base.originUserInfo || {};

const { cityCode, cityName } = store.state.base.cityInfo as NativeModel.CityInfo || {};

const adCode = (store.state.base.cityInfo as NativeModel.CityInfo || {}).adCode
|| (store.state.base.cityInfo as NativeModel.AliCityInfo || {}).cityAdcode
|| '';


@Component
export default class ApplyProcess extends Vue {
  @Prop(String) readonly commodityId!: string;

  @Prop(String) readonly financeVipType?: RightPackageTypeEnum;

  /** 是否显示老客升级入口 */
  @Prop(Boolean) readonly showUpgrade?: boolean;

  /** 是否显示领取额度入口，锁客逻辑 */
  @Prop(Boolean) readonly showPreApply?: boolean;

  /** 定价标签 */
  @Prop(String) readonly pricingType?: string;

  /** 是否显示兜底资方信息 */
  @Prop(Boolean) readonly showMoreCapitalInfo!: boolean;

  @ApplyResultStore.State orderDetail!: OrdersV2.OrderDetail;

  /** 海消展示状态 */
  @HomeStoreNamespace.State haiXiaoQueryData!: { hideApplyCreditEntry?: boolean } | null;

  private get applyAmount(): string {
    return String(this.orderDetail ? this.orderDetail.applyAmount : '');
  }

  /** 判断是否为自营 */
  private get isAutarky() {
    return this.commodityId === ProductCommodity.AUTARKY_B_COMMODITY;
  }

  /** 去授信获取新额度 */
  private goPreApply() {
    this.$emit('goPreApply');
  }

  /** 去授信获取新额度, 老客升级入口 */
  private goPreApplyUpgrade() {
    this.$ubtPageButtonNew('finance_withdrawResult_upgradeApply', {
      commodityId: this.commodityId,
      applyStatus: OrderResultEnum.LENDING,
    });
    this.goPreApply();
  }

  private mounted() {
    // 绑定埋点数据 供组件传递
    const npsEle = window.document.querySelector('quark-compass-nps-base');
    if (userGuid && npsEle) {
      npsEle.ubtBindData({
        userGuid,
        cityCode,
        cityName,
        adCode,
      });
    }
    if (this.financeVipType) {
      this.$ubtModuleExposeNew('finance_loan_applyResult_isFinanceVip', {
        packageType: this.financeVipType,
      });
    }

    if (this.showUpgrade) {
      this.$ubtModuleExposeNew('finance_withdrawResult_upgradeApply', {
        commodityId: this.commodityId,
        applyStatus: OrderResultEnum.LENDING,
      });
    }

    if (!this.showUpgrade) {
      this.$ubtModuleExposeNew('finance_withdrawResult_applyAmount', {
        commodityId: this.commodityId,
        applyStatus: OrderResultEnum.LENDING,
      });
    }

    this.$ubtModuleExposeNew('finance_withdrawResultSucceed_withdraw', {
      commodityId: this.commodityId,
      applyStatus: OrderResultEnum.LENDING,
    });
  }

  // private get isSuperVip() {
  //   return Number(this.financeVipType) === RightPackageTypeEnum.SUPER_MEMBER_CARD;
  // }

  private onChannelClick(channel: PreApplyItem) {
    handleChannelClick(this, channel, 'finance_withdrawResultSucceed_withdraw', OrderResultEnum.LENDING);
  }


  private render() {
    return (
      <div class={style.applyProcess}>
        <NewResultPage
          status={ResultPageStatusEnum.PROCESS}
          statusText={`提现${this.applyAmount}元，申请处理中`}
        >
          <div class={style.newTips}>预计24小时内完成提现申请，实际放款以短信为准</div>
        </NewResultPage>
        {/* 内嵌协议 slot */}
        {this.$scopedSlots.contract && this.$scopedSlots.contract({})}
        {/* 分期申请状态轮询卡片 slot */}
        {this.$scopedSlots.mall && this.$scopedSlots.mall({})}

        {this.showMoreCapitalInfo && <UndertakeInvestors
          loanOrderId={this.orderDetail.loanOrderId}
        />}

        {/** 成功购买超级会员卡后，展示金融会员页面,根据产品id区别是自营还是联营 */}
        {/* {
          this.isSuperVip
          && <div class={this.isAutarky ? style.autarkyMemberBanner : style.financeMemberBanner}/>
        } */}

        {/* 显示老客升级模块
        */}
        {
          this.showUpgrade && this.showPreApply && (
            <div
            class={style.upgradeBanner}
            onClick={this.goPreApplyUpgrade.bind(this)}
            ></div>
          )
        }
        {/* 剩余可借额度模块 */}
        <ChangeChannelList
          commodityId={this.commodityId}
          isNewChannel={true}
          onReApply={this.onChannelClick.bind(this)}
        />

        {/** nps组件
         * 使用文档：https://hellobike.yuque.com/lbqzgo/qmcnav/mn0tct3q90a7zz0y#quark-compass-nps-popup
         */}
        <div class={[style.applyResultNps, 'apply-result-nps']}>
          <quark-compass-nps-base
            env={appEnv}
            token={token}
            // 生产 id:  0ddac30bcdb54ebe8f029be27338c7aa fat id: 952e99e67b7343bebcff30b192e0e1ce
            survey-id= {isFatEnv ? '952e99e67b7343bebcff30b192e0e1ce' : '0ddac30bcdb54ebe8f029be27338c7aa' }
            code-key="ares_loan_nps"
            pagefrom=""
            validate-score-only
          />
        </div>
        {/** 提现申请页广告弹窗 */}
        <AdvApplyingPopup
          commodityId={this.commodityId}
          pricingType={this.pricingType}
        />
        {/* 没命中老客升级且非海消隐藏授信入口时，展示 申请新额度按钮 */}
        {((!this.showUpgrade && this.showPreApply)
        || (!this.haiXiaoQueryData?.hideApplyCreditEntry)) && (
          <div
            class={style.applyNewCreditWrapper}
            onClick={this.goPreApply.bind(this)}
          >
            <span class={style.applyNewCredit}>
              申请新额度
            </span>
          </div>
        )}
      </div>
    );
  }
}
